import { type InputTextSubmitEvent } from "shared/components/base/InputText.vue";
import { useValueWithPrevious as useValue } from "shared/composables/useValueWithPrevious";
import { isNonNullable } from "shared/types/guards";

type UseSocialConnectionsSearchParams = {
  onSearch: (query: string) => void;
};

// eslint-disable-next-line import/prefer-default-export
export function useSocialConnectionsSearch({
  onSearch,
}: UseSocialConnectionsSearchParams) {
  const { value: searchValue, update: updateSearch } = useValue<string>("");

  function handleSearchSubmit({ event, value }: InputTextSubmitEvent): void {
    if (event?.key !== "Enter") return;

    if (isNonNullable(value) && updateSearch(value)) {
      onSearch(value);
    }
  }

  function handleSearchClear() {
    if (updateSearch("")) onSearch("");
  }

  function handleSearchKeydown(event: KeyboardEvent) {
    if (event.key === "Space") event.preventDefault();

    if (event.key === "Escape") {
      searchValue.value.current = "";
      (event.target as HTMLElement)?.focus();

      if (updateSearch("")) onSearch("");
    }
  }

  function searchWatcher(newValue: string) {
    const cleanValue = newValue.replace(/#|@/g, "");

    if (searchValue.value) {
      searchValue.value.current = cleanValue.trim();
    }

    if (updateSearch(cleanValue)) {
      onSearch(cleanValue.trim());
    }
  }

  return {
    handleSearchClear,
    handleSearchKeydown,
    handleSearchSubmit,
    searchValue,
    searchWatcher,
  };
}
